import {
	Badge,
	Box,
	Divider,
	IconButton,
	Menu,
	MenuItem,
	Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import { connectSocket, disconnectSocket, socket } from "src/Utils/Socket";
import IndivisualNotification from "./IndivisualNotification";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useApiMutation } from "src/hooks/useApiMutation";
import { BarLoader } from "react-spinners";
export type INotification = {
	notification_id: number;
	notification_type: string;
	related_id: number;
	message: string;
	fair_id: number;
	created_at: string;
	read_status: 0 | 1;
};
const NotificationManagement = () => {
	const { data: notiList, isLoading } = useGetQueryWithTotal<INotification[]>(
		{
			endPoint: "/api/admin/notification",
			queryKeys: ["notification"],
			// params: { pagination, status },
		}
	);
	const { mutate: ClearAll, isPending } = useApiMutation<void, void>({
		method: "DELETE",
		endPoint: `/api/admin/notification`,
		invalidateQueries: ["notification"],
	});
	const [notifications, setNotifications] = useState<INotification[]>([]);
	const unseenCount = notifications.filter(
		(item) => item?.read_status === 0
	)?.length;

	useEffect(() => {
		connectSocket();

		// Listen for notifications
		socket.on("admin_notification", (data) => {
			console.log(data);
			setNotifications((prev) => [data, ...prev]); // Add new notification
		});

		// Cleanup on unmount
		return () => {
			socket.off("admin_notification"); // Remove the listener
			disconnectSocket(); // Disconnect socket
		};
	}, []);

	useEffect(() => {
		if (notiList?.data?.length) {
			setNotifications((prev) => [...notiList?.data]);
		}
	}, [notiList?.data]);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<Box>
			<IconButton
				size="medium"
				color="inherit"
				onClick={handleOpen}
				aria-label="notifications"
				sx={{ p: { xs: 0.5, sm: 1 } }}
			>
				<Badge
					badgeContent={unseenCount}
					color="error"
					overlap="circular"
				>
					<NotificationsIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
				</Badge>
			</IconButton>

			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				PaperProps={{
					elevation: 3,
					sx: {
						width: { xs: 290, sm: 380 },
						maxWidth: "92vw",
						maxHeight: 400,
						mt: 1,
						borderRadius: 2,
					},
				}}
			>
				<Box
					sx={{
						p: 2,
						backgroundColor: "#f5f5f5",
						display: "flex",
						justifyContent: "space-between",
					}}
				>
					<Typography variant="subtitle1" fontWeight="bold">
						Notifications
					</Typography>
					<Typography
						variant="subtitle1"
						fontWeight="bold"
						sx={{
							cursor: "pointer",
							"&:hover": {
								color: "green", // Add the desired hover color
							},
						}}
						onClick={() => ClearAll()}
					>
						Clear All
					</Typography>
				</Box>
				<Divider />

				{notifications?.length === 0 ? (
					<MenuItem disabled>
						<Typography variant="body2" color="text.secondary">
							No new notifications
						</Typography>
					</MenuItem>
				) : isLoading || isPending ? (
					<BarLoader />
				) : (
					notifications?.map((notif, index) => (
						<IndivisualNotification
							key={index}
							id={notif?.notification_id}
							notif={notif}
						/>
					))
				)}

				<Divider />
				<Box
					sx={{
						p: 2,
						textAlign: "center",
						backgroundColor: "#f9f9f9",
					}}
				>
					<Typography
						variant="body2"
						color="primary"
						sx={{
							cursor: "pointer",
							"&:hover": { textDecoration: "underline" },
						}}
						onClick={() => {
							console.log("View all notifications");
							handleClose();
						}}
					>
						View All Notifications
					</Typography>
				</Box>
			</Menu>
		</Box>
	);
};

export default NotificationManagement;
